import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { navList } from "../data/Data";
import SocialIcons from "./SocialIcons";
import { useAuth } from "../context/AuthContext";

export default function Header() {
  const { user } = useAuth();
  const [navbarOpen, setNavbarOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const location = useLocation();

  const toggleNavbar = () => setNavbarOpen((prev) => !prev);

  const closeNavbar = () => {
    setNavbarOpen(false);
    setActiveDropdown(null);
  };

  const handleDropdownToggle = (id) => {
    setActiveDropdown((prev) => (prev === id ? null : id));
  };

  return (
    <>
      <header className="hk-navbar-wrapper">
        <div className="hk-navbar-inner container-fluid px-3 px-lg-4">
          {/* Left: Brand */}
          <div className="hk-brand-wrapper">
            <Link to="/" className="hk-brand-link" onClick={closeNavbar}>
              <span className="hk-brand-main">HariKunj</span>
              <span className="hk-brand-sub">Resort</span>
            </Link>
          </div>

          {/* Center: Desktop nav links — capsule pills */}
          <nav className="hk-nav d-none d-lg-flex">
            {navList.map((item) => {
              const isActiveTop =
                item.path !== "/page" && location.pathname === item.path;

              if (item.subItems) {
                return (
                  <div
                    key={item.id}
                    className="hk-nav-item hk-nav-dropdown"
                    onMouseEnter={() => setActiveDropdown(item.id)}
                    onMouseLeave={() => setActiveDropdown(null)}
                  >
                    <button
                      type="button"
                      className={`hk-nav-link hk-nav-capsule hk-nav-button ${activeDropdown === item.id ? "hk-nav-capsule--active" : ""
                        }`}
                    >
                      {item.text}
                      <span className="hk-nav-chevron">▾</span>
                    </button>
                    <div
                      className={`hk-dropdown-menu ${activeDropdown === item.id ? "hk-dropdown-menu--show" : ""
                        }`}
                    >
                      {item.subItems.map((sub) => {
                        const isActiveSub = location.pathname === sub.path;
                        return (
                          <Link
                            key={sub.id}
                            to={sub.path}
                            className={`hk-dropdown-item ${isActiveSub ? "hk-dropdown-item--active" : ""
                              }`}
                            onClick={closeNavbar}
                          >
                            {sub.text}
                          </Link>
                        );
                      })}
                    </div>
                  </div>
                );
              }

              return (
                <Link
                  key={item.id}
                  to={item.path}
                  className={`hk-nav-item hk-nav-link hk-nav-capsule ${isActiveTop ? "hk-nav-capsule--active" : ""
                    }`}
                  onClick={closeNavbar}
                >
                  {item.text}
                </Link>
              );
            })}
          </nav>

          {/* Right: Login/Guest Suite + Social + burger */}
          <div className="hk-right-wrapper">
            {user ? (
              <Link
                to={user.role === "admin" ? "/admin-dashboard" : "/user-dashboard"}
                className="hk-check-booking-btn d-none d-lg-inline-flex"
                style={{ background: "rgba(254, 161, 22, 0.15)", border: "1.5px solid #FEA116", color: "#FEA116" }}
              >
                <i className="fas fa-user" style={{ marginRight: "6px", fontSize: "0.7rem" }}></i>
                Guest Suite
              </Link>
            ) : (
              <Link
                to="/login"
                className="hk-check-booking-btn d-none d-lg-inline-flex"
              >
                <i className="fas fa-sign-in-alt" style={{ marginRight: "6px", fontSize: "0.7rem" }}></i>
                Login
              </Link>
            )}

            <div className="hk-social d-none d-lg-flex">
              <SocialIcons />
            </div>

            {/* Mobile toggler */}
            <button
              type="button"
              className={`hk-burger d-lg-none ${navbarOpen ? "hk-burger--open" : ""}`}
              onClick={toggleNavbar}
              aria-label="Toggle navigation"
            >
              <span />
              <span />
              <span />
            </button>
          </div>
        </div>

        {/* Mobile nav overlay */}
        <div
          className={`hk-mobile-nav d-lg-none ${navbarOpen ? "hk-mobile-nav--open" : ""
            }`}
        >
          <nav className="hk-mobile-nav-inner">
            {navList.map((item) => {
              const isActiveTop =
                item.path !== "/page" && location.pathname === item.path;

              if (item.subItems) {
                return (
                  <div key={item.id} className="hk-mobile-item-wrapper">
                    <button
                      type="button"
                      className="hk-mobile-link hk-mobile-capsule hk-mobile-link--dropdown"
                      onClick={() => handleDropdownToggle(item.id)}
                    >
                      <span>{item.text}</span>
                      <span
                        className={`hk-mobile-chevron ${activeDropdown === item.id ? "hk-mobile-chevron--open" : ""
                          }`}
                      >
                        ▾
                      </span>
                    </button>
                    <div
                      className={`hk-mobile-dropdown ${activeDropdown === item.id
                        ? "hk-mobile-dropdown--show"
                        : ""
                        }`}
                    >
                      {item.subItems.map((sub) => {
                        const isActiveSub = location.pathname === sub.path;
                        return (
                          <Link
                            key={sub.id}
                            to={sub.path}
                            className={`hk-mobile-sub-link ${isActiveSub ? "hk-mobile-sub-link--active" : ""
                              }`}
                            onClick={closeNavbar}
                          >
                            {sub.text}
                          </Link>
                        );
                      })}
                    </div>
                  </div>
                );
              }

              return (
                <Link
                  key={item.id}
                  to={item.path}
                  className={`hk-mobile-link hk-mobile-capsule ${isActiveTop ? "hk-mobile-capsule--active" : ""
                    }`}
                  onClick={closeNavbar}
                >
                  {item.text}
                </Link>
              );
            })}

            {user ? (
              <Link
                to={user.role === "admin" ? "/admin-dashboard" : "/user-dashboard"}
                className="hk-mobile-check-booking mt-2"
                onClick={closeNavbar}
                style={{ background: "rgba(254, 161, 22, 0.15)", border: "1.5px solid #FEA116", color: "#FEA116" }}
              >
                <i className="fas fa-user" style={{ marginRight: "8px" }}></i>
                Guest Suite
              </Link>
            ) : (
              <Link
                to="/login"
                className="hk-mobile-check-booking mt-2"
                onClick={closeNavbar}
              >
                <i className="fas fa-sign-in-alt" style={{ marginRight: "8px" }}></i>
                Login
              </Link>
            )}

            <div className="hk-mobile-social">
              <SocialIcons />
            </div>
          </nav>
        </div>
      </header>

      {/* ═══════════  GLASSMORPHIC CAPSULE PILL STYLES  ═══════════ */}
      <style>{`
        /* Fixed header styles */

.hk-navbar-wrapper {
  position: fixed;
  top: 15px;
  left: 20px;
  right: 20px;
  z-index: 2000;
  border-radius: 24px;

  /* Luxury Royal Midnight Blue with blur */
  background: rgba(11, 29, 55, 0.55) !important;
  backdrop-filter: blur(20px) !important;
  -webkit-backdrop-filter: blur(20px) !important;

  border: 1.5px solid rgba(212, 175, 55, 0.35) !important;
  box-shadow: 0 8px 32px 0 rgba(5, 14, 26, 0.4) !important;
  transition: all 0.3s ease;
}

@media (max-width: 575.98px) {
  .hk-navbar-wrapper {
    top: 10px;
    left: 10px;
    right: 10px;
    border-radius: 16px;
  }
}

.hk-navbar-inner {
  width: 100%;
  margin: 0;
  padding: 0 2.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 62px;
}

       .hk-brand-wrapper {
  display: flex;
  align-items: center;
  justify-self: flex-start;
}

        .hk-brand-link {
  text-decoration: none;
  display: flex;
  flex-direction: column;
  line-height: 1;
  text-transform: uppercase;
  letter-spacing: 0.22em;
  padding: 0.4rem 1.1rem;
  border-radius: 999px;
  background: radial-gradient(circle at top, rgba(0, 0, 0, 0.75), rgba(0, 0, 0, 0.35));
  box-shadow: 0 10px 26px rgba(0, 0, 0, 0.8);
  border: 1px solid rgba(255, 191, 105, 0.6);
}


        .hk-brand-main {
  font-family: "Cinzel Decorative", serif;
  font-size: 1.4rem;
  font-weight: 800;
  color: #ffe8c2;
  text-shadow:
    0 0 6px rgba(0, 0, 0, 0.9),
    0 0 14px rgba(255, 191, 105, 0.9);
}


        .hk-brand-sub {
  font-family: "Cinzel", serif;
  font-size: 0.72rem;
  font-weight: 600;
  color: #ffdca0;
  letter-spacing: 0.28em;
  margin-top: 0.12rem;
  text-shadow:
    0 0 5px rgba(0, 0, 0, 0.9),
    0 0 10px rgba(255, 191, 105, 0.7);
}


        /* ═══ DESKTOP NAV — Capsule Pill Layout ═══ */
        .hk-nav {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex: 1;
  justify-content: center;
}

        .hk-nav-item {
          position: relative;
        }

/* ═══ CAPSULE PILL BASE (Desktop) ═══ */
.hk-nav-capsule {
  position: relative;
  border: 1.5px solid rgba(255, 255, 255, 0.12) !important;
  background: rgba(255, 255, 255, 0.04) !important;
  color: #ffffff !important;
  text-transform: uppercase;
  letter-spacing: 0.15em;
  font-size: 0.78rem;
  font-weight: 500;
  font-family: "Poppins", sans-serif;
  padding: 0.42rem 1.15rem !important;
  cursor: pointer;
  text-decoration: none !important;
  border-radius: 50px !important;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.4);
  transition: all 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.08), 0 2px 8px rgba(0, 0, 0, 0.15);
}

/* Hover: soft glow + golden border reveal */
.hk-nav-capsule:hover {
  background: rgba(30, 62, 114, 0.35) !important;
  border-color: rgba(212, 175, 55, 0.5) !important;
  color: #ffe8c2 !important;
  transform: translateY(-2px);
  box-shadow:
    inset 0 2px 4px rgba(5, 14, 26, 0.25),
    0 4px 16px rgba(212, 175, 55, 0.2),
    0 0 12px rgba(254, 161, 22, 0.15);
}

/* Active / Current page: fully lit capsule */
.hk-nav-capsule--active {
  background: rgba(30, 62, 114, 0.45) !important;
  border-color: rgba(212, 175, 55, 0.6) !important;
  color: #ffe8c2 !important;
  box-shadow:
    inset 0 2px 6px rgba(5, 14, 26, 0.3),
    0 4px 18px rgba(212, 175, 55, 0.25),
    0 0 14px rgba(254, 161, 22, 0.2);
}

/* Remove the old underline pseudo-element from capsule pills */
.hk-nav-capsule::after {
  display: none !important;
}

/* Keep the old rules for non-capsule fallback but override with capsule */
.hk-nav-link,
.hk-nav-button {
  position: relative;
  border: none;
  background: transparent;
  color: #ffffff;
  text-transform: uppercase;
  letter-spacing: 0.18em;
  font-size: 0.8rem;
  font-weight: 500;
  font-family: "Poppins", sans-serif;
  padding: 0.35rem 1rem 0.8rem;
  cursor: pointer;
  text-decoration: none;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.4);
  transition: color 0.25s ease, transform 0.25s ease;
}

        .hk-nav-link::after,
        .hk-nav-button::after {
          content: "";
          position: absolute;
          left: 50%;
          bottom: 0.25rem;
          width: 0;
          height: 2px;
          border-radius: 999px;
          background: linear-gradient(
  180deg,
  #ffa600 0%,
  #ff9500 100%
);

          box-shadow: 0 0 8px rgba(255, 159, 28, 0.8);
          transform: translateX(-50%);
          transition: width 0.25s ease;
        }

        .hk-nav-link:hover,
        .hk-nav-button:hover {
          color: #ffffff;
          transform: translateY(-1px);
        }

        .hk-nav-link:hover::after,
        .hk-nav-button:hover::after {
          width: 70%;
        }

        .hk-nav-link--active {
          color: #fff7e0 !important;
        }

        .hk-nav-link--active::after {
          width: 70%;
        }

        .hk-nav-chevron {
          margin-left: 0.25rem;
          font-size: 0.5rem;
          opacity: 0.8;
        }

        /* DROPDOWN (desktop) */
        .hk-nav-dropdown {
          position: relative;
        }

        .hk-dropdown-menu {
          position: absolute;
          top: 100%;
          left: 50%;
          transform: translateX(-50%) translateY(10px);
          opacity: 0;
          visibility: hidden;
          min-width: 220px;
          background: rgba(11, 29, 55, 0.96) !important;
          backdrop-filter: blur(18px) !important;
          -webkit-backdrop-filter: blur(18px) !important;
          border-radius: 16px;
          padding: 8px;
          border: 1.5px solid rgba(212, 175, 55, 0.55) !important;
          box-shadow: 0 20px 50px rgba(0, 0, 0, 0.75), 0 0 22px rgba(254, 161, 22, 0.25) !important;
          z-index: 3000;
          transition: opacity 0.25s ease, transform 0.25s ease, visibility 0.25s ease;
        }

        .hk-dropdown-menu--show {
          opacity: 1;
          visibility: visible;
          transform: translateX(-50%) translateY(6px);
        }

        .hk-dropdown-item {
          display: block;
          padding: 10px 16px;
          border-radius: 10px;
          color: #FAF6F0 !important;
          font-size: 0.78rem;
          font-weight: 600;
          letter-spacing: 0.12em;
          text-transform: uppercase;
          text-decoration: none !important;
          font-family: "Poppins", sans-serif;
          transition: all 0.25s ease;
          border: 1px solid transparent;
        }

        .hk-dropdown-item:hover {
          background: linear-gradient(135deg, #FEA116 0%, #D4AF37 100%) !important;
          color: #050E1A !important;
          transform: translateX(4px);
          box-shadow: 0 6px 16px rgba(254, 161, 22, 0.35);
          font-weight: 700;
        }

        .hk-dropdown-item--active {
          background: rgba(254, 161, 22, 0.2) !important;
          border-color: rgba(212, 175, 55, 0.45) !important;
          color: #FEA116 !important;
          font-weight: 700;
        }

        /* ═══ CHECK BOOKING BUTTON (Desktop) ═══ */
        .hk-check-booking-btn {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          padding: 0.4rem 1.2rem;
          border-radius: 50px;
          border: 1.5px solid rgba(212, 175, 55, 0.55);
          background: linear-gradient(135deg, rgba(254, 161, 22, 0.12), rgba(212, 175, 55, 0.08));
          color: #FEA116;
          font-family: "Poppins", sans-serif;
          font-size: 0.75rem;
          font-weight: 600;
          letter-spacing: 0.1em;
          text-transform: uppercase;
          cursor: pointer;
          transition: all 0.3s ease;
          backdrop-filter: blur(6px);
          -webkit-backdrop-filter: blur(6px);
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
          white-space: nowrap;
        }

        .hk-check-booking-btn:hover {
          background: linear-gradient(135deg, #FEA116, #D4AF37);
          color: #050E1A;
          transform: translateY(-2px);
          box-shadow: 0 4px 16px rgba(254, 161, 22, 0.35);
          border-color: transparent;
        }

        .hk-right-wrapper {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  justify-self: flex-end;
}

        /* ═══════════ LUXURY BUBBLE SOCIAL ICONS (Second Image Style) ═══════════ */
        .hk-social-icons-container {
          display: inline-flex;
          align-items: center;
          gap: 0.65rem;
          padding: 0.2rem 0;
        }

        .hk-bubble-icon {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 40px;
          height: 40px;
          border-radius: 50% !important;
          position: relative;
          overflow: hidden;
          text-decoration: none !important;
          cursor: pointer;
          
          /* Shiny, luxury 3D bubble radial gradient - mimicking the second image's glass/soft feel */
          background: radial-gradient(
            circle at 30% 30%,
            #ffffff 0%,
            #f2f5fa 40%,
            #dbe4f0 75%,
            #b8cbe0 100%
          ) !important;
          
          /* Semi-transparent glossy white border */
          border: 1.5px solid rgba(255, 255, 255, 0.95) !important;
          
          /* Dual-layer realistic 3D bubble depth shadows + soft outer drop shadow */
          box-shadow: 
            inset 0 3px 6px rgba(255, 255, 255, 0.95), 
            inset 0 -3px 6px rgba(11, 36, 71, 0.12),
            0 4px 10px rgba(5, 14, 26, 0.22),
            0 1px 3px rgba(0, 0, 0, 0.08) !important;
          
          transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
        }

        /* Gloss bubble light reflection highlight at the top left */
        .hk-bubble-icon::before {
          content: "";
          position: absolute;
          top: 2px;
          left: 6px;
          width: 28px;
          height: 13px;
          border-radius: 50% / 40%;
          background: linear-gradient(
            to bottom, 
            rgba(255, 255, 255, 0.9) 0%, 
            rgba(255, 255, 255, 0) 100%
          );
          pointer-events: none;
          z-index: 2;
        }

        /* Icon tag itself: dark royal cobalt navy blue by default */
        .hk-bubble-icon i {
          color: #0b2447 !important;
          font-size: 1.05rem !important;
          text-shadow: none !important;
          transition: all 0.3s ease;
          position: relative;
          z-index: 1;
        }

        /* Hover: scale up, dynamic bounce, gold backglow, inner colors shift */
        .hk-bubble-icon:hover {
          transform: translateY(-3px) scale(1.1) !important;
          background: radial-gradient(
            circle at 30% 30%,
            #ffffff 0%,
            #fafbfc 30%,
            #e8f2ff 70%,
            rgba(254, 161, 22, 0.25) 100%
          ) !important;
          border-color: rgba(254, 161, 22, 0.8) !important; /* Gold border reveal */
          box-shadow: 
            inset 0 3px 6px rgba(255, 255, 255, 0.95), 
            inset 0 -3px 6px rgba(254, 161, 22, 0.12),
            0 8px 20px rgba(254, 161, 22, 0.38),
            0 2px 5px rgba(0, 0, 0, 0.12) !important;
        }

        .hk-bubble-icon:hover i {
          color: #ff9500 !important; /* Elegant Jodhpur Saffron Gold color on hover */
          transform: scale(1.08) !important;
        }

        /* Active press animation */
        .hk-bubble-icon:active {
          transform: translateY(-1px) scale(0.96) !important;
          box-shadow: 
            inset 0 2px 5px rgba(0, 0, 0, 0.18), 
            0 2px 4px rgba(254, 161, 22, 0.2) !important;
        }

        /* BURGER */
        .hk-burger {
          width: 36px;
          height: 28px;
          border: none;
          background: transparent;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 4px 3px;
          cursor: pointer;
        }

        .hk-burger span {
          display: block;
          height: 2px;
          border-radius: 999px;
          background: #ffe8d1;
          box-shadow: 0 0 6px rgba(255, 191, 105, 0.9);
          transition: transform 0.25s ease, opacity 0.25s ease;
        }

        .hk-burger--open span:nth-child(1) {
          transform: translateY(7px) rotate(45deg);
        }
        .hk-burger--open span:nth-child(2) {
          opacity: 0;
        }
        .hk-burger--open span:nth-child(3) {
          transform: translateY(-7px) rotate(-45deg);
        }

        /* ═══ MOBILE NAV OVERLAY ═══ */
        .hk-mobile-nav {
          position: absolute;
          top: 58px;
          left: 0;
          right: 0;
          max-height: 0;
          overflow: hidden;
          background: rgba(11, 29, 55, 0.98) !important;
          backdrop-filter: blur(20px) !important;
          -webkit-backdrop-filter: blur(20px) !important;
          border-radius: 20px;
          border: 1.5px solid rgba(212, 175, 55, 0.45) !important;
          box-shadow: 0 16px 40px rgba(5, 14, 26, 0.7) !important;
          transition: max-height 0.35s ease, opacity 0.3s ease, visibility 0.3s ease;
          z-index: 9999 !important;
          opacity: 0;
          visibility: hidden;
          pointer-events: none;
        }

        .hk-mobile-nav--open {
          max-height: 80vh !important;
          overflow-y: auto !important;
          opacity: 1 !important;
          visibility: visible !important;
          pointer-events: auto !important;
        }

        .hk-mobile-nav-inner {
          padding: 0.75rem 1rem 1rem;
          display: flex;
          flex-direction: column;
          gap: 0.5rem;
        }

        /* ═══ MOBILE CAPSULE PILLS ═══ */
        .hk-mobile-capsule {
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          gap: 8px;
          font-family: "Poppins", sans-serif;
          font-size: 0.85rem;
          text-transform: uppercase;
          letter-spacing: 0.15em;
          color: #ffe1c0 !important;
          padding: 0.55rem 1.1rem !important;
          text-decoration: none !important;
          border: 1.5px solid rgba(255, 255, 255, 0.1) !important;
          border-radius: 50px !important;
          background: rgba(255, 255, 255, 0.03) !important;
          transition: all 0.3s ease;
          width: 100%;
        }

        .hk-mobile-capsule:hover {
          background: rgba(30, 62, 114, 0.3) !important;
          color: #FEA116 !important;
          border-color: rgba(254, 161, 22, 0.5) !important;
        }

        .hk-mobile-capsule--active {
          background: linear-gradient(135deg, rgba(254, 161, 22, 0.25), rgba(212, 175, 55, 0.25)) !important;
          border-color: #FEA116 !important;
          color: #FEA116 !important;
          box-shadow: 0 4px 14px rgba(254, 161, 22, 0.25);
        }

        .hk-mobile-item-wrapper {
          width: 100%;
        }

        .hk-mobile-link--dropdown {
          width: 100%;
          cursor: pointer;
        }

        .hk-mobile-chevron {
          transition: transform 0.3s ease;
          display: inline-block;
          font-size: 0.8rem;
          color: #D4AF37;
        }

        .hk-mobile-chevron--open {
          transform: rotate(180deg);
        }

        .hk-mobile-dropdown {
          max-height: 0;
          overflow: hidden;
          transition: max-height 0.3s ease;
          display: flex;
          flex-direction: column;
          gap: 0.35rem;
          padding-left: 0.75rem;
          margin-top: 0.25rem;
        }

        .hk-mobile-dropdown--show {
          max-height: 300px;
        }

        .hk-mobile-sub-link {
          font-family: "Poppins", sans-serif;
          font-size: 0.8rem;
          color: #d2c5b3 !important;
          text-decoration: none !important;
          padding: 0.45rem 1rem !important;
          border-radius: 30px !important;
          background: rgba(255, 255, 255, 0.02) !important;
          border: 1px solid rgba(255, 255, 255, 0.05) !important;
          transition: all 0.25s ease;
          display: block;
          text-align: center;
        }

        .hk-mobile-sub-link:hover,
        .hk-mobile-sub-link--active {
          color: #FEA116 !important;
          background: rgba(254, 161, 22, 0.15) !important;
          border-color: rgba(254, 161, 22, 0.4) !important;
        }

        /* ═══ MOBILE CHECK BOOKING BUTTON ═══ */
        .hk-mobile-check-booking {
          display: flex;
          align-items: center;
          justify-content: center;
          font-family: "Cinzel", serif;
          font-size: 0.85rem;
          font-weight: 700;
          letter-spacing: 0.15em;
          text-transform: uppercase;
          color: #050E1A !important;
          background: linear-gradient(135deg, #FEA116, #D4AF37) !important;
          padding: 0.65rem 1.2rem !important;
          border-radius: 50px !important;
          text-decoration: none !important;
          box-shadow: 0 4px 16px rgba(254, 161, 22, 0.4);
          transition: all 0.3s ease;
          width: 100%;
        }

        .hk-mobile-check-booking:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(254, 161, 22, 0.6);
        }

        .hk-mobile-social {
          margin-top: 0.5rem;
          padding-top: 0.75rem;
          border-top: 1px solid rgba(255, 255, 255, 0.1);
          display: flex;
          justify-content: center;
        }

        /* RESPONSIVE TWEAKS FOR MOBILE & DESKTOP NAVBAR */
        @media (max-width: 991.98px) {
          .hk-nav,
          .hk-social,
          .hk-right-wrapper > .hk-check-booking-btn {
            display: none !important;
          }

          .hk-burger {
            display: flex !important;
            margin-left: auto !important;
          }

          .hk-navbar-wrapper {
            top: 10px !important;
            left: 10px !important;
            right: 10px !important;
            width: calc(100vw - 20px) !important;
            max-width: calc(100vw - 20px) !important;
            border-radius: 16px !important;
            box-sizing: border-box !important;
            overflow: visible !important;
          }

          .hk-navbar-inner {
            width: 100% !important;
            max-width: 100% !important;
            box-sizing: border-box !important;
            min-height: 52px !important;
            padding-left: 0.6rem !important;
            padding-right: 0.6rem !important;
            margin: 0 !important;
            display: flex !important;
            align-items: center !important;
            justify-content: space-between !important;
            background: rgba(11, 29, 55, 0.95) !important;
            backdrop-filter: blur(20px) !important;
            -webkit-backdrop-filter: blur(20px) !important;
            border-radius: 16px !important;
          }

          .hk-brand-wrapper {
            flex-shrink: 0 !important;
          }

          .hk-right-wrapper {
            flex-shrink: 0 !important;
            margin-left: auto !important;
            display: flex !important;
            align-items: center !important;
          }

          .hk-brand-main {
            font-size: 0.92rem;
            letter-spacing: 0.18em;
          }

          .hk-brand-sub {
            font-size: 0.58rem;
            letter-spacing: 0.22em;
          }

          .hk-brand-link {
            padding: 0.3rem 0.75rem;
          }

          .hk-mobile-nav {
            position: absolute !important;
            top: 58px !important;
            left: 0 !important;
            right: 0 !important;
            width: 100% !important;
            max-width: 100% !important;
            box-sizing: border-box !important;
          }
        }

        @media (min-width: 992px) {
          .hk-nav {
            display: flex !important;
          }
          .hk-social {
            display: flex !important;
          }
          .hk-right-wrapper > .hk-check-booking-btn {
            display: inline-flex !important;
          }
          .hk-burger,
          .hk-mobile-nav {
            display: none !important;
          }
        }
      `}</style>
    </>
  );
}
